export default __webpack_public_path__ + "static/media/vignetteMachineMarly.cbb52f9a.jpg";